module.exports = __webpack_public_path__ + "img/CV.7bdf40be.jpg";